import { Component, OnInit, Input, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-smash-countdown',
  templateUrl: './smash-countdown.component.html',
  styleUrls: ['./smash-countdown.component.scss'],
})
export class SmashCountdownComponent implements OnInit, OnDestroy {

  @Input() endDate: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }
  private parsedEndDate: Date;
  private counter: Observable<number>;
  private subscription: Subscription;
  message: any;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.parsedEndDate = new Date(this.endDate);
      this.message = this.parseCountdown(Math.floor((this.parsedEndDate.getTime() - new Date().getTime()) / 1000));
      this.counter = interval(1000).pipe(map(() => Math.floor((this.parsedEndDate.getTime() - new Date().getTime()) / 1000)));
      this.subscription = this.counter.subscribe((x) => { this.message = this.parseCountdown(x); });
    }
  }

  parseCountdown(t) {
    if (t > 0) {
      const days = Math.floor(t / 86400);
      t -= days * 86400;
      const hours = Math.floor(t / 3600) % 24;
      t -= hours * 3600;
      const minutes = Math.floor(t / 60) % 60;
      t -= minutes * 60;
      const seconds = t % 60;

      const message = {
        days: days.toString(),
        hours: this.addLeadingZero(hours),
        minutes: this.addLeadingZero(minutes),
        seconds: this.addLeadingZero(seconds)
      };

      return message;
    } else {
      return null;
    }
  }

  addLeadingZero(numb: number) {
    if (numb < 10) {
      return '0' + numb;
    }
    return numb.toString();
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.subscription.unsubscribe();
    }
  }
}
